import { create } from "zustand";
import { persist } from "zustand/middleware";

const ONE_DAY_MS = 86400 * 1000;

interface ExoshockPopupState {
  dismissedUntil: number;
  dismiss: () => void;
}

/**
 * 홈 팝업의 EXOSHOCK 슬라이드 「오늘은 다시 보지 않기」 상태.
 *
 * VRChat(`tactglove-vrchat-popup-store`) · 할로윈(`halloween-2026-popup-store`)과 같은 형태 · 저장 키만 나눈다 — 한
 * 저장소를 공유하면 한 슬라이드를 끌 때 다른 캠페인까지 함께 꺼진다. 오늘 닫혔는지 판정은 `popup-banner-store` 의
 * `isDismissedToday` 를 같이 쓴다.
 */
export const useExoshockPopupStore = create<ExoshockPopupState>()(
  persist(
    (set) => ({
      dismissedUntil: 0,
      dismiss: () => set({ dismissedUntil: Date.now() + ONE_DAY_MS }),
    }),
    {
      name: "exoshock-popup",
      partialize: (state) => ({ dismissedUntil: state.dismissedUntil }),
    },
  ),
);
